export function formatCurrency(amount: number | undefined | null): string {
  const formattedCurrency = (amount || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formattedCurrency;
}

/**
 * Formats a fee/number for display with comma separation (e.g., 10000 -> "10,000").
 * Used in offer letter dialog fee inputs.
 */
export function formatFeeWithCommas(value: number | string | undefined | null): string {
  if (value === undefined || value === null || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
  if (Number.isNaN(num)) return '';
  return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

/**
 * Parses a fee input string (with optional commas) to a number.
 * Returns undefined for empty or invalid input.
 */
export function parseFeeInput(value: string): number | undefined {
  const trimmed = value.trim().replace(/,/g, '');
  if (trimmed === '') return undefined;
  const num = parseFloat(trimmed);
  return Number.isNaN(num) ? undefined : num;
}
